"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var CoachUser = /*#__PURE__*/function () {
  function CoachUser(client) {
    (0, _classCallCheck2["default"])(this, CoachUser);
    this.client = client;
    this.resourceUrl = '/user';
  }

  (0, _createClass2["default"])(CoachUser, [{
    key: "getUserTimeline",
    value: function getUserTimeline(userId) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return this.client.get("".concat(this.resourceUrl, "/").concat(userId, "/timeline"), args);
    }
  }, {
    key: "updatePlanExpiry",
    value: function updatePlanExpiry(userId, expiresOn) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      return this.client.put("".concat(this.resourceUrl, "/").concat(userId, "/update-plan-expiry"), expiresOn, args);
    }
  }, {
    key: "removePaywall",
    value: function removePaywall(data) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      return this.client.post('/payment/remove-paywall', data, args);
    }
  }, {
    key: "getTimezone",
    value: function getTimezone() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return this.client.get('/coach/timezone', args);
    }
  }, {
    key: "updateTimezone",
    value: function updateTimezone(data) {
      for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        args[_key5 - 1] = arguments[_key5];
      }

      return this.client.patch('/coach/timezone', data, args);
    }
  }, {
    key: "syncCalendars",
    value: function syncCalendars() {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return this.client.post('/coach/sync-calendars', {}, args);
    }
  }, {
    key: "getCalendars",
    value: function getCalendars() {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return this.client.get('/coach/calendars', args);
    }
  }, {
    key: "updateCalendarSelection",
    value: function updateCalendarSelection(calendarId, data) {
      for (var _len8 = arguments.length, args = new Array(_len8 > 2 ? _len8 - 2 : 0), _key8 = 2; _key8 < _len8; _key8++) {
        args[_key8 - 2] = arguments[_key8];
      }

      return this.client.patch("/coach/calendars/".concat(calendarId), data, args);
    }
  }, {
    key: "getAvailableSlotsPreview",
    value: function getAvailableSlotsPreview(data) {
      for (var _len9 = arguments.length, args = new Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
        args[_key9 - 1] = arguments[_key9];
      }

      return this.client.post('/coach/available-slots-preview', data, args);
    }
  }]);
  return CoachUser;
}();

exports["default"] = CoachUser;